"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _twitch = _interopRequireDefault(require("./twitch.theme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var twitch = {
  app: {
    atomicPublisherUnit: "user",
    atomicFollowerUnit: "follower"
  },
  brand: {
    codename: "twitch",
    name: "Twitch",
    color: _twitch["default"].tenant.primary,
    logoProps: {
      name: "twitchLogo"
    }
  },
  profile: {
    details: [{
      title: "Primary Category",
      dataKey: "category"
    }, {
      title: "Language",
      dataKey: "language_label"
    }],
    metrics: [{
      title: "SlateScore",
      dataKey: "slatescore",
      enclosed: true
    }, {
      title: "Subscribers",
      dataKey: "fan_count"
    }, {
      title: "Videos",
      dataKey: "video_count"
    }, {
      title: "Views",
      dataKey: "views_sum"
    }],
    videoMetrics: [{
      title: "VPV (Last 30)",
      dataKey: "views_per_video_last_30_days"
    }, {
      title: "Views (Last 30)",
      dataKey: "monthly_views"
    }, {
      title: "Likes Per Video",
      dataKey: "like_count_avg"
    }, {
      title: "Avg Length",
      dataKey: "duration_seconds_avg",
      type: "duration"
    }],
    videosGrid: {
      tabs: [{
        title: "Most Recent",
        icon: "today",
        dataKey: "mostRecent",
        order: "pub_date",
        query: {
          ordering: "-pub_date"
        }
      }, {
        title: "Most Engaging",
        icon: "thumb_up",
        dataKey: "mostEngaged",
        order: "engagement_count",
        query: {
          ordering: "-reaction_count"
        }
      }, {
        title: "High Risk",
        icon: "warning",
        dataKey: "highRisk",
        order: "risk_sort_only",
        query: {
          ordering: "-pub_date",
          brandsafety_video_label: "High Risk"
        }
      }],
      thumbnailMetrics: [{
        label: "Reactions",
        dataKey: "reaction_count",
        type: "number"
      }, {
        label: "Published",
        dataKey: "pub_date",
        type: "date"
      }]
    },
    videos: [{
      title: "Highest Risk",
      icon: "warning",
      dataKey: "highRisk",
      query: {
        order: "blended_bs_score",
        ordering: "-blended_bs_score,-pub_date",
        brandsafety_video_label: "High Risk"
      }
    }, {
      title: "Most Watched Videos",
      icon: "remove_red_eye",
      dataKey: "mostEngaged",
      query: {
        order: "engagement_count",
        ordering: "-view_count"
      }
    }, {
      title: "Most Recent Videos",
      icon: "today",
      dataKey: "mostRecent",
      query: {
        order: "pub_date",
        ordering: "-pub_date"
      }
    }],
    tags: {
      title: "Top Tags"
    }
  },
  mainCatalog: {
    headerColor: "purple",
    headerIcon: "ribbon",
    experimentalSearchEnabled: false,
    featuredMetrics: [{
      label: "Monthly Views",
      dataKey: "monthly_views_sum",
      icon: "views"
    }, {
      label: "Users",
      dataKey: "count",
      icon: "channel"
    }, {
      label: "Videos",
      dataKey: "video_count_sum",
      icon: "videosTriangle"
    }],
    facets: [{
      label: "Quality",
      filters: ["SlateScoreFilter"]
    }, {
      label: "Suitability Ratings",
      filters: ["SuitabilityFilter"],
      tooltip: "SuitabilityDescriptionList"
    }, {
      label: "Primary Category",
      filters: ["ContentCategoryFilter"]
    }, {
      label: "Audience",
      filters: ["FanCountFilter", {
        label: "Monthly Views",
        type: "MonthlyViewsFilter",
        queryParam: "monthly_views__range",
        aggregatesKey: "monthly_views"
      }, "LanguageFilter"]
    }],
    table: {
      defaultSortOrder: "-video_count",
      columns: [{
        dataKey: "picture",
        cellType: "picture"
      }, {
        label: "User Name",
        dataKey: "title",
        cellType: "title"
      }, {
        label: "SlateScore",
        dataKey: "unified_slatescore",
        cellType: "slateScore"
      }, {
        label: "Tweets",
        dataKey: "video_count",
        cellType: "number",
        "default": true
      }, {
        label: "Rating",
        dataKey: "suitability",
        cellType: "suitability"
      }, {
        label: "Followers",
        dataKey: "fan_count",
        cellType: "number"
      }, {
        label: "Language",
        dataKey: "language_label"
      }]
    }
  },
  videoCatalog: {
    header: {
      showHighRisk: {
        requiredPermissions: []
      }
    },
    table: {
      columns: [{
        dataKey: "thumbnail",
        cellType: "videoThumbnail"
      }, {
        label: "Title",
        dataKey: "title",
        cellType: "videoTitle"
      }, {
        label: "Publish Date",
        dataKey: "pub_date",
        cellType: "date"
      }, {
        label: "Risk Flag",
        dataKey: "brandsafety_video_label",
        cellType: "highRiskFlag"
      }]
    }
  },
  videoPlayer: {
    videoStats: [{
      label: "Likes",
      dataKey: "like_count"
    }, {
      label: "Views",
      dataKey: "view_count"
    }, {
      label: "Comments",
      dataKey: "comment_count"
    }],
    externalLink: {
      label: "View on twitch",
      iconProps: {
        name: "twitchLogo"
      }
    }
  },
  charts: {},
  reporting: {
    pageTitle: "DV Intelligence",
    apiService: "configReportingService",
    pollingInterval: 5000,
    headerColor: "berry",
    headerIcon: "chart",
    hasSearch: true,
    wizard: {
      report_type: "twitch_channel_impressions",
      multiCampaignArray: true,
      button: {
        text: "Create Report",
        variant: "outlined"
      },
      component: "CampaignPicker",
      source: "/campaigns",
      steps: ["campaigns", "scheduler", "confirm"]
    },
    catalog: {
      source: "/reports",
      defaultSortParam: "-modified",
      defaultAggregates: {
        modified_by__username: []
      },
      toolbar: {
        fetchAggregates: false,
        // If application uses SOLR, this is not needed
        // Otherwise this will map an individual param to an endpoint request
        // Could be updated to incorporate an array
        aggregateRequests: [{
          name: "modified_by__username",
          endpoint: "/reports/modified_by",
          getDisplayNames: function getDisplayNames(options) {
            var defaultUserName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "OS Report Bot";
            var updatedOptions = options.map(function (user) {
              var fullName = user.email === "" ? user.fullName = defaultUserName : "".concat(user.first_name, " ").concat(user.last_name);
              return _objectSpread(_objectSpread({}, user), {}, {
                fullName: fullName
              });
            });
            return updatedOptions;
          }
        }],
        filters: [{
          component: "splitDate",
          key: "modified__range__split",
          end_name: "modified__lte",
          start_name: "modified__gte",
          withTime: true
        }]
      },
      columns: [
      // TODO: How to add checkbox in the header here?
      {
        dataKey: "name",
        label: "Name",
        tableCellProps: {
          style: {
            minWidth: 200
          }
        },
        wrapWord: true
      }, {
        cellType: "multiCampaign",
        dataKey: "campaign_id",
        label: "Campaign ID",
        field: "campaign_id",
        sortKey: "campaign__campaign_id",
        wrapNone: true
      }, {
        cellType: "multiCampaign",
        dataKey: "campaign_name",
        label: "Campaign Name",
        field: "campaign_name",
        sortKey: "campaign__campaign_name",
        tableCellProps: {
          style: {
            minWidth: 200
          }
        },
        wrapWord: true
      }, {
        cellType: "date",
        dataKey: "start_date",
        dateFormat: "%m/%d/%y",
        sorting: false,
        label: "Start Date"
      }, {
        cellType: "date",
        dataKey: "end_date",
        dateFormat: "%m/%d/%y",
        sorting: false,
        label: "End Date"
      }, {
        cellType: "ossUserName",
        defaultValue: "OS Report Bot",
        dataKey: "modified_by",
        sorting: false,
        label: "Modified By"
      }, {
        cellType: "date",
        dataKey: "modified",
        dateFormat: "%m/%d/%y",
        label: "Modified Date"
      }, {
        cellType: "reportStatus",
        label: "Status",
        sorting: false,
        dataKey: "state",
        TableCellProps: {
          align: "center",
          textAlign: "center"
        }
      }, {
        cellType: "ossActionMenu",
        actionMenuIcon: "download",
        actionMenuType: "download",
        sorting: false,
        onClick: "actionMenuClicked",
        TableCellProps: {
          align: "center",
          textAlign: "center"
        }
      }, {
        cellType: "ossActionMenu",
        actionMenuIcon: "settings",
        actionMenuType: "settings",
        onClick: "actionMenuClicked",
        sorting: false,
        TableCellProps: {
          align: "center"
        }
      }],
      actionMenus: [{
        openKey: "download",
        source: "/reports",
        twitch_channel_impressions: [{
          label: "PDF Report",
          path: "reports/:id/base_pdf"
        }, {
          label: "PPT Report",
          path: "reports/:id/base_ppt"
        }, {
          label: "Report Files",
          path: "reports/:id/output_zip"
        }, {
          label: "Channels Not Verified",
          path: "reports/:id/channels_not_verified_csv"
        }]
      }, {
        openKey: "settings",
        menuOptions: [{
          label: "Edit",
          action: "openInspector"
        }, {
          label: "Cancel",
          action: "request",
          endpoint: "/reports/:id/cancel",
          method: "post",
          success: "Report Cancelled",
          permittedConditions: ["new", "pending", "generating_metadata", "processing", "preparing", "process_queued"]
        }, {
          label: "Refresh",
          action: "request",
          endpoint: "/reports/:id/refresh",
          method: "post",
          success: "Report Refreshed",
          permittedConditions: ["ready", "published", "canceled", "error", "scheduled"]
        }, {
          label: "Delete",
          action: "delete",
          endpoint: "/reports/:id",
          method: "delete",
          success: "Report Deleted",
          permittedConditions: ["ready", "published", "canceled", "error", "scheduled"]
        }]
      }]
    },
    inspector: {
      deeplinkKey: "report_id",
      // This method parses out the required fields for editing a report
      // If a new field become editable, it would go in here
      getEditParams: function getEditParams(reportInfo) {
        return {
          campaign: reportInfo.campaign,
          name: reportInfo.name,
          start_date: reportInfo.start_date,
          end_date: reportInfo.end_date
        };
      },
      fetchMinMaxDates: {
        source: "/campaigns/:id",
        infoIdKey: "campaign",
        minDateKey: "data_start_date",
        maxDateKey: "data_end_date"
      },
      header: {
        title: "Report Info",
        deeplink: true
      },
      downloadOptions: {
        twitch_channel_impressions: {
          permittedConditions: ["ready", "published"],
          options: [{
            label: "PDF Report",
            path: "reports/:id/base_pdf"
          }, {
            label: "PPT Report",
            path: "reports/:id/base_ppt"
          }, {
            label: "Report Files",
            path: "reports/:id/output_zip"
          }, {
            label: "Channels not Verified",
            path: "reports/:id/channels_not_verified_csv"
          }]
        }
      },
      sections: {
        summary: {
          title: "Summary Info",
          fields: [{
            objectKey: "name",
            label: "Name",
            component: "text",
            // Only fields with this value are allowed to be editable
            isEditable: function isEditable(reportInfo) {
              return (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by) && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.first_name) !== "" && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.last_name) !== "" && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.email) !== "";
            }
          }, {
            objectKey: "id",
            label: "Id",
            component: "text",
            copyButton: true,
            preCopyTooltip: "Copy Report Id"
          }, {
            objectKey: "modified",
            label: "Modified Date",
            component: "singleDate"
          }, {
            objectKey: "modified_by",
            label: "Modified By",
            component: "username",
            defaults: {
              first_name: "OS",
              last_name: "Report Bot",
              email: ""
            }
          }, {
            // Passing an array will collect the required values to be passed into the component
            objectKey: ["start_date", "end_date", "data_start_date", "data_end_date"],
            label: "Date Range",
            component: "dateRange",
            // Only fields with this value are allowed to be editable
            isEditable: function isEditable(reportInfo) {
              return (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by) && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.first_name) !== "" && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.last_name) !== "" && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.email) !== "";
            }
          }, {
            component: "empty"
          }, {
            objectKey: "campaigns",
            label: "Campaign Id",
            component: "multiCampaign",
            displayField: "campaign_id"
          }, {
            objectKey: "campaigns",
            label: "Campaign Name",
            component: "multiCampaign",
            displayField: "campaign_name"
          }]
        },
        schedule: {
          title: "Scheduled Delivery",
          fields: [{
            objectKey: "report_request",
            label: "Recurring Schedule",
            component: "dateFrequency"
          }, {
            objectKey: "report_request.end_date",
            label: "Ends",
            component: "singleDate"
          }, {
            objectKey: "report_request.next_run_date",
            label: "Next Run Date",
            component: "singleDate"
          }, {
            objectKey: "report_request.last_run_date",
            label: "Last Run Date",
            component: "singleDate"
          }, {
            objectKey: "email_recipients",
            label: "Sent To",
            component: "text"
          }, {
            objectKey: "report_request.timezone",
            label: "Timezone",
            component: "text"
          }]
        },
        metrics: {
          title: "Report Metrics Info",
          fields: [{
            objectKey: "brand_safe_impressions_pct",
            label: "Delivery to Bss",
            component: "metric",
            numType: "percent",
            metricMathMethod: function metricMathMethod(_ref) {
              var _ref$brand_safe_impre = _ref.brand_safe_impressions_pct,
                brand_safe_impressions_pct = _ref$brand_safe_impre === void 0 ? 0 : _ref$brand_safe_impre;
              var brandSafePercentage = brand_safe_impressions_pct * 100;
              return brandSafePercentage.toFixed(2); // "8.91%"
            }
          }, {
            objectKey: "measured_ad_impressions",
            label: "Impressions",
            component: "metric",
            numType: "int"
          }, {
            objectKey: "channels_count",
            label: "Channels",
            component: "metric",
            numType: "int"
          }]
        },
        history: {
          title: "State History",
          objectKey: "history",
          hasSearch: true,
          searchErrors: true,
          searchErrorKey: "state",
          primarySearchKey: "history_change_reason",
          secondarySearchKey: "state",
          dataDisplayKeys: [{
            type: "state",
            title: "State",
            objectKey: "state"
          }, {
            type: "date",
            title: "Date",
            objectKey: "history_date"
          }, {
            type: "user",
            title: "User",
            objectKey: "modified_by"
          }, {
            type: "message",
            title: "Message",
            objectKey: "history_change_reason"
          }]
        }
      }
    }
  },
  navigationMenu: [{
    label: "DV Content Settings",
    iconProps: {
      name: "contentRatings"
    },
    routeRef: "mainCatalog",
    routeRefMatches: ["mainCatalog", "profile", "profileVideos"]
  }, {
    label: "Reports",
    iconProps: {
      name: "reports"
    },
    routeRef: "reporting",
    routeRefMatches: ["reporting"]
  }],
  routes: {
    home: {
      url: "/",
      title: "Home"
    },
    mainCatalog: {
      url: "/users",
      title: "DV Content Settings",
      component: "MainCatalog",
      requiredPermissions: ["view_profiles_catalog"],
      "default": true
    },
    profile: {
      url: "/user/:id",
      title: "DV Content Settings",
      component: "Profile",
      requiredPermissions: ["view_profile"]
    },
    profileVideos: {
      url: "/user/:id/videos",
      title: "DV Content Settings",
      requiredPermissions: ["view_videos_catalog"],
      component: "Profile"
    },
    profileVideo: {
      url: "/user/:id/videos/:videoId",
      title: "DV Content Settings",
      component: "Profile"
    },
    reporting: {
      component: "ConfigReporting",
      requiredPermissions: ["view_reports_catalog"],
      title: "DV Intelligence",
      url: "/reports",
      "default": true
    },
    terms: {
      component: "Terms",
      title: "DV Terms and Conditions",
      url: "/terms"
    }
  }
};
var _default = exports["default"] = twitch;